<template lang="pug">
    div(id="mapid" @click="onClick" v-resize="onResize")
        div(class="leaflet-top leaflet-right" style="pointer-events: auto;")
            v-btn(icon color="black" text @click.stop="debouncedOnMenuClicked")
                v-icon view_headline
        div(class="leaflet-top leaflet-right" style="pointer-events: auto; margin-top: 35px; margin-end: 0px")
            v-btn(icon @click="centerMapOnMe")
                v-icon my_location
        TrainStationDepartures(v-show=false, ref='ts_dep', :train_station="current_train_station" style="width: 350px; height: 300px ")
        div(class="leaflet-top leaflet-right" style="margin-top: 70px ; margin-end: 5px")
            v-progress-circular(v-if="loading_cities", indeterminate, color="black")

</template>

<script>
// import TrainStationDepartures from "./TrainStationDepartures.vue";
import TrainStationsMixin from "./MapViewMixins/TrainStationsMixin.vue"
import CampingSitesMixin from "./MapViewMixins/CampingSitesMixin.vue"
import PathMixin from "./MapViewMixins/PathMixin.vue"
import RainviewerMixin from "./MapViewMixins/RainViewerMixin.vue"
import CityWeatherMixin from "./MapViewMixins/CityWeatherMixin.vue"
import FriendsLocMixinVue from './MapViewMixins/FriendsLocMixin.vue';

import { app_state, app_mgr, OnLiveLocalizationChanged } from './../js/app_state'
import { colorMappings } from './../js/mappings'
import 'leaflet-contextmenu'
import './../../node_modules/leaflet-contextmenu/dist/leaflet.contextmenu.css'

const TrainStationDepartures = () => import("./TrainStationDepartures.vue");

/* global L:  true */

var _ = require('lodash');

export default {

    mixins: [TrainStationsMixin, CampingSitesMixin, PathMixin, RainviewerMixin, CityWeatherMixin, FriendsLocMixinVue],

    components: {
        TrainStationDepartures,
    },

    data() {
        return {
            mymap: null,
            lastpos: null,
            localization_marker: null,
            is_dragging: false,
            live_localization: false,
            layer_control: null,
            overlay_maps: {},
            heightgraph: null,
        }
    },

    mounted() {
        // list of all base layers
        var cyclosm = L.tileLayer('https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png', {
                                        attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap contributors</a>'
                                        , useCache: true
                                        , crossOrigin: true
                                        }),
            openstreetmap = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                                        attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap contributors</a>'
                                        , useCache: true
                                        , crossOrigin: true
                                        });
        // creation of the map
        const saved_center = localStorage.getItem("center");
        let map_center = [48.832397, 2.355582];
        if (saved_center) {
            const saved_center_split = saved_center.split(",");
            const lat = parseFloat(saved_center_split[0]);
            const lng = parseFloat(saved_center_split[1]);
            if (lat && lng) {
                map_center = [lat, lng];
            }
        }
        const saved_zoom = localStorage.getItem("zoom");
        let map_zoom = 10;
        if (saved_zoom) {
            const saved_zoom_float = parseFloat(saved_zoom);
            if (saved_zoom_float) {
                map_zoom = saved_zoom_float;
            }
        }
        this.mymap = L.map('mapid', {
            center: map_center,
            zoom: map_zoom,
            layers: cyclosm,
            zoomControl: false,
            contextmenu: true,
            contextmenuItems: [{
                text: 'Start route from here',
                callback: this.setStartPoint,
                }, {
                text: 'End route here',
                callback: this.setEndPoint,
                }]
        });
        // creation of layers control
        const base_maps = {
            "CyclOSM": cyclosm,
            "OpenStreetmap": openstreetmap
        }
        this.layer_control = L.control.layers(base_maps, this.overlay_maps);
        this.layer_control.setPosition('bottomleft');
        this.layer_control.addTo(this.mymap);

        const h = ' <svg xmlns="http://www.w3.org/2000/svg" height="35" viewBox="0 0 35 35" width="35" fill="orange">\
                        <path d="M0 0h24v24H0z" fill="none"/>\
                        <path d="M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"/>\
                    </svg>';
        const generic_icon = L.divIcon({html: h,
                                        className: 'empty',
                                        });
        this.localization_marker = L.marker(this.mymap.getCenter(), {icon: generic_icon}).addTo(this.mymap);
        this.localization_marker.setOpacity(0);
        this.mymap.on('locationfound', (evt) => {
            this.localization_marker.setLatLng(evt.latlng);
            this.localization_marker.setOpacity(100);
            
            if (!app_state.live_localization) {
                // test necessaire pour ne pas recentrer la carte sur appel de live_localization
                // si pas de live_localization, c'est que l'event vient de centerOnMe()
                this.mymap.setView(this.localization_marker.getLatLng(), this.mymap.getZoom());
            }

            this.current_position = evt.latlng;
            if (this.mymap.hasLayer(this.city_markers))
                this.onLocateEnded();
        });
        this.mymap.on('locationerror', (evt) => {
            /* eslint-disable no-console */
            console.log(evt.message);
            /* eslint-enable no-console */
            if (evt.code == 1) {
                // user did not accept geolocation
                app_mgr.setLiveLocalizationState(false);
            }
            // else we do not stop the locate() from live_localization
        });
        OnLiveLocalizationChanged.push(() => { this.onLiveLocalizationChanged(); });
        app_mgr.bounding_box_getter = () => 
        {
            const bb = this.mymap.getBounds();
            return [bb.getSouth(), bb.getWest(), bb.getNorth(), bb.getEast()];
        };
        
        this.debouncedOnMenuClicked = _.debounce(this.onMenuClicked, 2, true);
        this.mymap.on('overlayadd', this.onOverlayAdd);
        this.mymap.on('overlayremove', this.onOverlayRemove);
        this.mymap.on('moveend', this.onMoveend);
        this.mymap.on('zoomend', this.onZoomend);
        this.mymap.on('locationfound', (ev) => { app_mgr.setLocation(ev.latlng) });
        this.onZoomend();
        addEventListener("beforeunload", () => { this.onBeforeUnload(); });

        this.pathLayer = L.featureGroup();
        this.pathLayer.addTo(this.mymap);

        this.heightgraph = L.control.heightgraph({
            mappings: colorMappings,
            graphStyle: {
                opacity: 0.8,
                'fill-opacity': 0.5,
                'stroke-width': '2px'
            },
        });
    },

    methods: {
        onClick(e) {
            this.lastpos = this.mymap.mouseEventToLatLng(e);
        },

        onMenuClicked() {
            this.$emit('menuClicked');
        },

        onOverlayAdd(e) {
            if (e.name == "Rainviewer") {
                if (app_state.rainviewerTimestamps.length != 0) {
                    // show slider only if overlays and timestamps are in app_state
                    this.$emit('rainviewerOverlayAdded');
                }
                this.updateTimestampsFromServer();
            }
            if (e.name == "Weather") {
                this.onCitiyWeatherLayerAdded();
                // this.onAnimationEnd();
                if (!this.needFillingTimestamps) {
                    this.$emit('weatherOverlayAdded');
                }
            }
        },

        onOverlayRemove(e) {
            if (e.name == "Rainviewer") {
                this.$emit('rainviewerOverlayRemoved');
                for (let overlay of app_state.rainviewer_layers) {
                    if (this.mymap.hasLayer(overlay)){
                        this.mymap.removeLayer(overlay);
                    }
                }
            }
            if (e.name == "Weather") {
                this.$emit('weatherOverlayRemoved');
                if (this.mymap.hasLayer(this.city_markers)) {
                    this.mymap.removeLayer(this.city_markers);
                }
                this.latest_weather_timestamp = ""; // to update weather data at next layer display
            }
        },

        onLiveLocalizationChanged() {
            if (app_state.live_localization) {
                this.mymap.locate({watch: true, enableHighAccuracy:true});
            } else {
                this.mymap.stopLocate();
                this.localization_marker.setOpacity(0);
            }
            this.live_localization = app_state.live_localization;
        },

        centerMapOnMe() {
            if (app_state.live_localization) {
                // si on a live_locallization, la geoloc est déjà connue, on centre la carte
                this.mymap.setView(this.localization_marker.getLatLng(), 16);
            } else {
                // sinon on la demande et en cas de succes on centre la carte
                this.mymap.locate();
            }
        },

        onMoveend() {
            if (this.mymap.hasLayer(this.city_markers)) {
                this.onAnimationEnd();
            }
        },

        onZoomend() {
            this.$emit("zoomChanged", this.mymap.getZoom());
        },

        // called by before unload
        onBeforeUnload() {
            const center = this.mymap.getCenter();
            if (center.lat && center.lng) {
                localStorage.setItem("center", [center.lat, center.lng]);
            }
            // localStorage.set("layer", )
            const zoom = this.mymap.getZoom();
            if (zoom) {
                localStorage.setItem("zoom", this.mymap.getZoom());
            }
        },

        setStartPoint(e) {
            app_state.waypoints[0].update(e.latlng.lng, e.latlng.lat,"");
        },

        setEndPoint(e) {
            if(app_state.waypoints.length > 1) {
                app_state.waypoints[app_state.waypoints.length - 1].update(e.latlng.lng, e.latlng.lat,"");
            }
            else {
                app_mgr.addWaypoint(e.latlng.lng, e.latlng.lat,0);
                app_state.waypoints[app_state.waypoints.length - 1].update(e.latlng.lng, e.latlng.lat,"");
            }
        },
    },
}
</script>

<style>
@media only screen and (max-width: 340px) {
    .leaflet-control-attribution {
        font-size: 8px !important;
    }
}
#mapid {
    z-index: 0;
    height:100%;
    width: 100%;
}
</style>

